module.exports = {
	attributes: [],
	enabled_attributes: [],
	categories: [],
	products: [],
	selectedProduct: null,
};
